export default __webpack_public_path__ + "static/media/plural-logo-v0-magenta.637aea83.svg";